<template>
  <div>
    <div>
      <Titulo :titulo="'Informes - ' + routeName" />
    </div>
    <div class="margin-informes">
      <!-- coger el parametro que se envio por la ruta -->
      <!-- {{$route.params.id}} -->
      <br />
      <!--
        @props
            data: Array,            required: true
            pagination: boolean,    required: false
            perPage: Number,        required: false
            SetectFiltro: Array     required: false
            filtro: boolean         required: false
      -->
      <table-component
        :data="data"
        pagination
        filtro
        showExportToExcel
        :perPage="perPage"
        :dataLength="dataLength"
        @click-buscar="buscar"
        @click-event="clickEvent"
      >
        <table-column
          slot="label"
          :label="'Nombre'"
          v-bind:value="'nombre'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Cédula'"
          v-bind:value="'cedula'"
        ></table-column>
        <table-column
          slot="label"
          :label="'modelo'"
          v-bind:value="'modelo'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Pagaré'"
          v-bind:value="'pagare'"
        ></table-column>
        <table-column
          slot="label"
          :label="'observacion'"
          v-bind:value="'observacion'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Estado'"
          v-bind:value="'estado_adjunto'"
        ></table-column>
      </table-component>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import SelectNovedad from "@/data/SelectQueEsNovedad.json";
import SelectTipoNovedad from "@/data/SelectTipoNovedad.json";

import XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "SubirInformes",
  data() {
    return {
      SelectNovedad: SelectNovedad,
      SelectTipoNovedad: SelectTipoNovedad,
      selectQueEsNovedad: "",
      selectTipoNovedad: "",
      perPage: 25,
      informe_url: "portal/informes/subsanacion",
      fileName: "Subsanaciones ",
    };
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  computed: {
    ...mapGetters({
      TablaVerProducto: "pages/TablaVerProducto",
      SelectFiltroTabla: "pages/SelectFiltroTabla",
      loading: "loading",
    }),
    dataLength() {
      return this.$store.getters["pages/total"];
    },
    data() {
      return this.$store.getters["pages/dataInformes"];
    },
    routeName() {
      return this.$router.currentRoute.name;
    },
  },
  methods: {
    buscar(event) {
      this.loadData(this.perPage, event.page);
    },
    async clickEvent(data, slug) {
      switch (slug) {
        case "paginacion":
          this.perPage = data.nRows;
          this.loadData(data.nRows, data.page);
          break;
        case "export-to-excel":
          this.$toasted.show("Por favor espere mientras exportamos los datos", {
            theme: "toasted-primary",
            position: "top-center",
            duration: 5000,
          });
          this.$store.commit("SET_LOADING", true);
          try {
            const result = await this.$store.state.api.get(this.informe_url, {
              params: { paginar: 0 },
            });
            let sheet = XLSX.utils.json_to_sheet(result.data.datos, {
              header: [
                "nombre",
                "cedula",
                "modelo",
                "pagare",
                "observacion",
                "estado_adjunto",
              ],
            });

            sheet["A1"].v = "Nombre";
            sheet["B1"].v = "Cédula";
            sheet["C1"].v = "Modelo";
            sheet["D1"].v = "Pagaré";
            sheet["E1"].v = "Observación";
            sheet["F1"].v = "Estado del documento";

            var workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, sheet, this.fileName);
            var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
            var wbout = XLSX.write(workbook, wopts);
            saveAs(
              new Blob([wbout], { type: "application/octet-stream" }),
              this.fileName + ".xlsx"
            );
            this.$toasted.show("El archivo fue exportado exitosamente", {
              theme: "toasted-primary",
              position: "top-right",
              duration: 10000,
            });
          } catch (err) {
            this.$toasted.show(
              "Ocurrió un error al intentar exportar el archivo",
              {
                theme: "toasted-primary",
                position: "top-right",
                duration: 10000,
              }
            );
          }
          this.$store.commit("SET_LOADING", false);
          break;
      }
    },
    loadData(row, page = 1, paginar = 1) {
      this.$store.dispatch("pages/fetch", {
        endpoint: this.informe_url,
        params: {
          row: this.perPage,
          page: page,
          paginar: paginar,
        },
      });
    },
  },
  mounted() {
    this.loadData(this.perPage, 1);
  },
};
</script>